import { useMutation } from '@apollo/client/react';
import { ConfirmationDialog } from '@optools/components/dialog/confirmation-dialog';
import { InfoButton, InfoButtonTrigger } from '@optools/components/info-button';
import { SYNC_MEDIA_CONTENT } from '@optools/services/operator-gateway/btc/mutations';
import { FolderSync } from 'lucide-react';
import { toast } from 'sonner';

export interface SyncAssetsButtonProps {
  gamePk: number;
}

export function SyncAssetsButton({ gamePk }: SyncAssetsButtonProps) {
  const [syncMediaContentMutation, { loading }] = useMutation(SYNC_MEDIA_CONTENT, {
    onCompleted: ({ syncMediaContent }) => {
      const description = syncMediaContent?.length ? (
        <>
          <h2 className="mb-1">Content synced for Media IDs</h2>
          <ul className="list-disc pl-4">
            {syncMediaContent.map((mediaId, index) => (
              <li key={`${mediaId}-${index}`}>{mediaId}</li>
            ))}
          </ul>
        </>
      ) : (
        ''
      );

      toast.success('Sync Assets Success', { description, duration: 10000 });
    },
  });

  return (
    <InfoButton description="Syncs the Skywalker assets with the content registry media" size="sm">
      <ConfirmationDialog
        description="Are you sure you want to sync the assets?"
        title="Sync Assets"
        onConfirm={() => syncMediaContentMutation({ variables: { gamePk } })}>
        <InfoButtonTrigger disabled={loading} loading={loading}>
          <FolderSync />
          Sync Assets
        </InfoButtonTrigger>
      </ConfirmationDialog>
    </InfoButton>
  );
}
